import {
  getVideoSegmentationDataMockHandler,
  getProfilesMockHandler,
  selectProfileMockHandler,
  selectVariantMockHandler,
  getReferralDataMockHandler,
} from '@/features/user/api';

export const userHandlers = [
  getProfilesMockHandler,
  selectProfileMockHandler,
  selectVariantMockHandler,
  getVideoSegmentationDataMockHandler,
  getReferralDataMockHandler,
];
